module.exports = __webpack_public_path__ + "static/img/scenic_spots.3c9b114.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/scenic_spots.png
// module id = R/sf
// module chunks = 1